"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StandardOrderItem = _interopRequireDefault(require("../OrderItem/StandardOrderItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint react/jsx-one-expression-per-line: 0 */
// TODO: refactor free products to use StandardOrderItem component instead
var OrderItems = function OrderItemsComponent(_ref) {
  var items = _ref.items;
  return items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_StandardOrderItem["default"], {
      item: item,
      key: item.productName
    });
  });
};

OrderItems.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};
var _default = OrderItems;
exports["default"] = _default;